import ApiService from "../../../commons/services/ApiService";
import CompanyAPI from "../../company/CompanyAPI";

const apiService = new ApiService();
const companyAPI = new CompanyAPI();

export default class NotificationAPI {

    URI_V1 = "/v1/notifications"

    saveConnectionToFirebase = async (data: any) => {
        return await apiService.post(`${this.URI_V1}/firebase`, data);
    };

    getNotifications = async () => {
        return await apiService.get(`${this.URI_V1}?companyId=${companyAPI.getCompanyManagment().id}`,);
    };

    countNotifications = async () => {
        return await apiService.get(`${this.URI_V1}/count?companyId=${companyAPI.getCompanyManagment().id}`,);
    };

    markAsRead = async (notificationId: any) => {
        return await apiService.put(`${this.URI_V1}/${notificationId}/markAsRead`, null);
    };

    getEnabledNotify = async () => {
        return await apiService.get(`${this.URI_V1}/status?companyId=${companyAPI.getCompanyManagment().id}`,);
    };

    
    
}
